<template lang='pug'>
  .bf-activate.component
    table.t1(summary='BlueFaucet Merchant Features')
      caption Merchant Features
      thead
        tr
          th Features
          th FREE
          th PAID
      tbody
        tr
          th Customer Management
          td &#10004
          td &#10004
        tr
          th Appointment Management
          td &#10004
          td &#10004
        tr
          th Customer History
          td &#10005
          td &#10004
        tr
          th Coupon Management
          td &#10005
          td &#10004
        tr
          th Gift Card
          td &#10005
          td &#10004
        tr
          th Membership
          td &#10005
          td &#10004
        tr
          th Price
          td FREE
          td $39/mo

    bf-button(@click.native='upgrade')
      template(v-slot:text) {{ $t('Activate Business Function') }}
</template>

<script>
  import { db } from '@/main'
  import { View } from '@/mixins/view'

  export default {
    name: 'bf-activate',

    mixins: [View],

    methods: {
      upgrade() {
        db.collection('accounts').doc(this.account.id).set(
          { merchant: true },
          { merge: true }
        ).then( () => this.$router.push('/profile') )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  table
    max-width 640px
    width 100%
    border 1px solid rgba( 0 0 0 .2 )
    border-collapse collapse
    caption
      font-weight bolder
      margin-bottom 16px
      font-size 1.2em
    th, td
      text-align center
      padding 8px
      border 1px dotted rgba( 0 0 0 .1 )
      &:first-child
        text-align left
    thead
      color white
      background rgb( 25 170 240 )

  .bf-activate
    overflow-y auto
    .bf-button
      display block
      margin 0 auto
      margin-top 24px
      background rgb( 25 170 240 )
      font-size 1.25em
      font-weight bold
      width auto
      padding 12px 32px
      border-radius 0
      font-size 1em
</style>
